/* eslint-disable react/prop-types */
// ClientesList page components
import IdCell from 'layouts/pages/finantial/invoice-list/components/IdCell';
import DefaultCell from 'layouts/pages/finantial/invoice-list/components/DefaultCell';
import CustomerCell from 'layouts/pages/finantial/invoice-list/components/CustomerCell';
import axios from 'axios';
import StatusCell from 'layouts/ecommerce/orders/order-list/components/StatusCell';

const fetchData = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/finance/invoice-list/`);
    const invoices = response.data;

    const rows = invoices.map((invoice) => ({
      id: invoice.id_cobranza,                // ✅ id REAL para acciones
      id_cobranza: invoice.id_cobranza,       // opcional, por claridad
      numero: invoice.numero,                 // solo visual
      fechaEmision: invoice.fecha,
      rut: invoice.rut,
      moneda: invoice.moneda,
      estado: invoice.estado,
      cliente: [invoice.cliente, { image: invoice?.cliente?.charAt?.(0) || 'N/A' }],
      tipoCambio: invoice.cambio,
      valor: invoice.valor,
      // acciones: la agregas donde ya lo haces en la página (si corresponde)
    }));

    return {
      columns: [
        { Header: 'id', accessor: 'id', Cell: ({ value }) => <IdCell id={value} /> },
        { Header: 'Numero de cobranza', accessor: 'numero', Cell: ({ value }) => <DefaultCell value={value} /> },
        {
          Header: 'Cliente',
          accessor: 'cliente',
          Cell: ({ value: [name, data] }) => (
            <CustomerCell image={data.image} color={data.color || 'dark'} name={name} />
          ),
        },
        {
          Header: 'Estado',
          accessor: 'estado',
          Cell: ({ value }) => {
            if (value === 1) {
              return <StatusCell icon="send" color="warning" status="No Enviada" />;
            } else if (value === 2) {
              return <StatusCell icon="send" color="success" status="Enviada" />;
            }
            return <StatusCell icon="close" color="error" status="Anulada" />;
          },
        },
        { Header: 'fecha de emision', accessor: 'fechaEmision', Cell: ({ value }) => <DefaultCell value={value} /> },
        { Header: 'Moneda', accessor: 'moneda', Cell: ({ value }) => <DefaultCell value={value} /> },
        { Header: 'Rut', accessor: 'rut', Cell: ({ value }) => <DefaultCell value={value} /> },
        { Header: 'Tipo Cambio', accessor: 'tipoCambio', Cell: ({ value }) => <DefaultCell value={value} /> },
        { Header: 'Valor', accessor: 'valor', Cell: ({ value }) => <DefaultCell value={value} /> },
        { Header: 'Acciones', accessor: 'acciones', disableSortBy: true, Cell: ({ row }) => row.original.acciones },
      ],
      rows,
    };
  } catch (error) {
    console.error('Error fetching finance data:', error);
    return { columns: [], rows: [] };
  }
};

export default fetchData;
